import React from 'react';
import {useGetMessages} from '../../../../hooks';
import {useFormContext} from 'react-hook-form';
import {makeStyles, FormControl, FormLabel} from '@material-ui/core';
import {Input, Select} from '../../../../components/v2';
import {GuardianInfo} from '../../../../../shared/types';

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(4)
    },
    header: {
        marginBottom: theme.spacing(2)
    },
    formLabel: {
        color: theme.palette.text.secondary
    }
}));

export type GuardianFieldValues = GuardianInfo;

export const Guardian = React.memo(props => {
    const styles = useStyles();
    const methods = useFormContext<GuardianFieldValues>();
    const messages = useGetMessages({
        header: 'epic.affiliate.guardian.region.header',
        required: 'errors.com.epicgames.validation.required_field.v2',
        firstName: 'epic.affiliate.signup.guardian.first.name',
        lastName: 'epic.affiliate.signup.guardian.last.name',
        relationship: 'epic.affiliate.signup.guardian.relationship',
        father: 'epic.affiliate.signup.guardian.relationship.father',
        mother: 'epic.affiliate.signup.guardian.relationship.mother',
        other: 'epic.affiliate.signup.guardian.relationship.other'
    });

    const checkHasError = () => {
        const {errors} = methods.formState;
        const {firstName, lastName, relationship} = errors;
        return !!(firstName || lastName || relationship);
    };

    return (
        <FormControl className={styles.root} component="fieldset" error={checkHasError()} required>
            <FormLabel className={styles.header} component="legend">
                {messages.header}
            </FormLabel>
            <Input
                required
                name="firstName"
                label={messages.firstName}
                control={methods.control}
                rules={{required: {value: true, message: messages.required}}}
            />
            <Input
                required
                name="lastName"
                label={messages.lastName}
                control={methods.control}
                rules={{required: {value: true, message: messages.required}}}
            />
            <Select
                required
                name="relationship"
                label={messages.relationship}
                control={methods.control}
                rules={{required: {value: true, message: messages.required}}}
                options={[
                    {value: '', children: messages.relationship},
                    {value: 'father', children: messages.father},
                    {value: 'mother', children: messages.mother},
                    {value: 'other', children: messages.other}
                ]}
            />
        </FormControl>
    );
});

export default Guardian;
